export default "__VITE_ASSET__BqAPkVYq__"